/* Gym Flooring UK - Flooring Specialist chat.
   Answers come from Claude through the Cloudflare Worker named in data-ai on #gfaPanel
   (snippets/gf-advisor.liquid); the Worker holds the expert brief and the live catalogue.
   If data-ai is empty or the Worker fails, the rule-based advisor below answers instead:
   every fact in it is taken from the product pages, the contact page or the refund policy.
   Prices come live from snippets/gf-advisor.liquid. */
(function () {
  'use strict';

  var PHONE = '01282 277 710', TEL = 'tel:01282277710';
  var WA = 'https://wa.me/447822012977?text=Hi%2C%20I%20need%20help%20choosing%20gym%20flooring';
  var EMAIL = 'sales@gymflooringuk.uk';
  var SAMPLES = '/pages/free-sample';
  var STORE_KEY = 'gfa_state_v1';

  /* ---------- Product knowledge (claims as published on each product page) ---------- */
  var INFO = {
    t16: { name: '16mm Interlocking Rubber Tiles', size: '500 x 500mm, 4 tiles = 1m²', cov: 0.25, unit: 'tile',
      spec: '70% impact absorption, 65% noise reduction, EN 13893 slip certified, 4.5kg per tile, 12-15 year commercial lifespan',
      pick: /500mm x 500mm x 16mm/i },
    t20: { name: '20mm Interlocking Rubber Tiles', size: '1m x 1m, 1 tile = 1m²', cov: 1, unit: 'tile',
      spec: '400kg drop rated, self-locking on all 4 sides, R10 slip resistance, up to 65dB sound reduction (house tested)' },
    cm20: { name: '20mm Cold-Moulded Rubber Tiles', size: '100 x 50cm, 2 tiles = 1m²', cov: 0.5, unit: 'tile',
      spec: '400kg rated, precision cold-moulded, low odour, up to 65dB sound reduction, 9kg per tile' },
    t30: { name: '30mm Heavy-Duty Rubber Tiles', size: '1m x 1m (also 500 x 500mm)', cov: 1, unit: 'tile',
      spec: '200kg+ drop rated for repeated overhead drops, 90% impact absorption, 85% noise reduction', pick: /1m x 1m/i },
    a30: { name: '30mm Acoustic Rubber Tiles', size: '1m x 1m (also 500 x 500mm)', cov: 1, unit: 'tile',
      spec: 'Up to 75dB sound reduction (house tested), 200kg+ drop rated, 1,000kg/m³ density', pick: /1m/i },
    t12: { name: '12mm Colour-Fleck Rubber Tiles', size: '1m x 1m, Blue/Black or White/Black', cov: 1, unit: 'tile',
      spec: 'EN 13893 slip certified, self-locking, matching ramp edges', pick: /12mm Thick \/ Blue/i },
    m17: { name: '17mm Interlocking Rubber Gym Mats', size: '3ft x 3ft (915mm), 0.84m² each', cov: 0.84, unit: 'mat',
      spec: '200kg drop rated, large format, yellow or black ramp edges', pick: /17mm/i },
    eva: { name: '12mm EVA Foam Tiles', size: '610 x 610mm, 0.37m² each', cov: 0.37, unit: 'tile',
      spec: 'Soft anti-fatigue foam, under 1kg per tile, grey or black, puzzle interlock' },
    rcut: { name: 'Cut-to-Length Rubber Roll', size: '1m wide, any length, 4-12mm', cov: 1, unit: 'metre', roll: true,
      spec: 'Seamless, priced per linear metre, 4 colours, EN 13893 non-slip' },
    r10: { name: '10m Crumb Rubber Roll', size: '10m x 1m (10m²), 4-12mm', cov: 10, unit: 'roll', roll: true,
      spec: 'Speckled commercial crumb finish, seamless 10m² per roll, 4 colours' },
    rsm: { name: '10m Smooth Rubber Roll', size: '10m x 1m (10m²), 4-12mm', cov: 10, unit: 'roll', roll: true,
      spec: 'Smooth commercial finish for cardio floors, studios and walkways, 4 colours' },
    ul: { name: 'Acoustic Underlay Roll', size: '10m x 1m (10m²), 4-12mm', cov: 10, unit: 'roll', roll: true,
      spec: 'Up to 72dB sound reduction, goes under tiles or rolls as an impact decoupling layer' }
  };

  var LIVE = {};
  try {
    var raw = JSON.parse(document.getElementById('gfa-data').textContent) || [];
    raw.forEach(function (p) { if (p && INFO[p.k]) LIVE[p.k] = p; });
  } catch (e) {}

  function variantFor(key, mm) {
    var p = LIVE[key], info = INFO[key];
    if (!p || !p.v.length) return null;
    var list = p.v.filter(function (v) { return !/ramp/i.test(v.t); });
    if (!list.length) list = p.v;
    if (mm) {
      var re = new RegExp('\\b' + mm + 'mm', 'i');
      var m = list.filter(function (v) { return re.test(v.t) && /black/i.test(v.t); })[0] ||
              list.filter(function (v) { return re.test(v.t); })[0];
      if (m) return m;
    }
    if (info.pick) { var pk = list.filter(function (v) { return info.pick.test(v.t); })[0]; if (pk) return pk; }
    return list[0];
  }
  function money2(pence) { return '£' + (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function perM2(key, mm) {
    var v = variantFor(key, mm); if (!v) return '';
    return money2(Math.round(v.p / INFO[key].cov)) + '/m²';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- State ---------- */
  var S = { space: null, act: null, up: null, area: null, dims: null, sub: null, asked: {}, convo: [] };
  var log, chips, input, panel, launch;
  var history = [];

  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ S: S, h: history.slice(-40), open: !panel.hidden })); } catch (e) {}
  }
  function restore() {
    try {
      var d = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (!d || !d.h || !d.h.length) return false;
      S = d.S; S.convo = S.convo || []; history = d.h;
      history.forEach(function (m) { paint(m.who, m.html); });
      return d.open;
    } catch (e) { return false; }
  }

  /* ---------- Rendering ---------- */
  function paint(who, html) {
    var el = document.createElement('div');
    el.className = 'gfa-msg gfa-msg--' + who;
    el.innerHTML = html;
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
  }
  function bot(html) { history.push({ who: 'bot', html: html }); paint('bot', html); }
  function user(text) { var h = esc(text); history.push({ who: 'user', html: h }); paint('user', h); }
  function setChips(list) {
    chips.innerHTML = '';
    (list || []).forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gfa-chip'; b.textContent = c[0];
      b.addEventListener('click', function () { handle(c[1] || c[0], c[0]); });
      chips.appendChild(b);
    });
    save();
  }
  function typing(cb) {
    var t = document.createElement('div');
    t.className = 'gfa-msg gfa-msg--bot gfa-typing';
    t.innerHTML = '<span></span><span></span><span></span>';
    log.appendChild(t); log.scrollTop = log.scrollHeight;
    setTimeout(function () { t.remove(); cb(); save(); }, 450);
  }

  function card(key, why, opts) {
    opts = opts || {};
    var info = INFO[key], p = LIVE[key];
    if (!p) return '';
    var v = variantFor(key, opts.mm);
    var price = v ? money2(v.p) + ' per ' + info.unit : '';
    var m2 = v && !info.roll && info.cov !== 1 ? ' <span class="gfa-card__m2">(' + perM2(key, opts.mm) + ')</span>' : '';
    var url = p.url + (v ? '?variant=' + v.id : '');
    var h = '<div class="gfa-card">' +
      (p.img ? '<img src="' + p.img + '" alt="" width="64" height="64" loading="lazy">' : '<span class="gfa-card__ph"></span>') +
      '<div class="gfa-card__body"><div class="gfa-card__name">' + esc(info.name) + (opts.mm ? ' <span class="gfa-card__mm">' + opts.mm + 'mm</span>' : '') + '</div>' +
      '<div class="gfa-card__price">' + price + m2 + '</div>' +
      '<div class="gfa-card__meta">' + esc(info.size) + '</div>' +
      (why ? '<div class="gfa-card__why">' + why + '</div>' : '') +
      '<a class="gfa-card__link" href="' + url + '">View product</a></div></div>';
    return h;
  }

  /* ---------- Parsing ---------- */
  var FT = /^(ft|feet|foot|')$/i;
  function parseSize(t) {
    var s = t.toLowerCase().replace(/,/g, '.');
    var U = "(cm|mm|m|mtrs?|metres?|meters?|ft|feet|foot|')?";
    var d = s.match(new RegExp('(\\d+(?:\\.\\d+)?)\\s*' + U + '\\s*(?:x|×|by|\\*)\\s*(\\d+(?:\\.\\d+)?)\\s*' + U));
    if (d && d[2] !== 'mm' && d[4] !== 'mm') {
      var a = parseFloat(d[1]), b = parseFloat(d[3]);
      var feet = FT.test(d[2] || '') || FT.test(d[4] || '') || /\bf(ee)?t\b|\bfoot\b/.test(s);
      var cm = d[2] === 'cm' || d[4] === 'cm';
      if (cm) { a /= 100; b /= 100; }
      if (feet) { a *= 0.3048; b *= 0.3048; }
      // 1m x 1m / 100 x 50cm are tile sizes, not rooms
      if (a > 1.01 || b > 1.01) {
        if (a < 200 && b < 200) return { dims: [a, b], area: a * b, feet: feet, unitless: !d[2] && !d[4] && !feet };
      }
    }
    var ar = s.match(/(\d+(?:\.\d+)?)\s*(m2|m²|sqm|sq\.?\s?m\b|square\s*met(?:re|er)s?|sq\.?\s?ft|sqft|ft2|ft²|square\s*f(?:ee|oo)t)/);
    if (ar) {
      var n = parseFloat(ar[1]);
      if (/ft|f(ee|oo)t/.test(ar[2])) n *= 0.092903;
      if (n > 0 && n < 5000) return { dims: null, area: n };
    }
    return null;
  }
  function has(t, re) { return re.test(t); }

  function detectSpace(t) {
    if (has(t, /outdoor|outside|garden|patio|bootcamp|decking/)) return 'outdoor';
    if (has(t, /yoga|pilates|dance|stretch|martial|judo|karate|bjj|jiu|mma|taekwondo|kids|child|play ?area|nursery|soft play/)) return 'soft';
    if (has(t, /cross ?fit|\bbox\b|functional|hiit|pt studio|personal train|bootcamp/)) return 'studio';
    if (has(t, /commercial|gym owner|leisure|school|university|college|hotel|facility|club|council|office gym/)) return 'commercial';
    if (has(t, /garage|shed|outbuilding|summer ?house|log cabin|barn/)) return 'garage';
    if (has(t, /\bhome\b|spare room|bedroom|\bhouse\b|loft|conservatory|basement|cellar|living room/)) return 'home';
    if (has(t, /cardio (area|zone|room)|treadmill area/)) return 'cardio';
    return null;
  }
  function detectAct(t) {
    if (has(t, /olympic|snatch|clean and jerk|clean & jerk|power clean|hang clean|drop(ping)? (the )?(bar|weight)|drops|cross ?fit|overhead drop|bumper/)) return 'drop';
    if (has(t, /squat rack|power rack|\brack\b|barbell|deadlift|power ?lift|bench press|heavy weight|heavy lifting|free weights?|plates?|smith/)) return 'barbell';
    if (has(t, /dumbbell|kettlebell|machine|multi ?gym|cable|weights|lifting|resistance/)) return 'dumbbell';
    if (has(t, /treadmill|bike|spin|rower|rowing|cardio|cross ?trainer|elliptical|bodyweight|stretch|yoga|pilates|class|aerobic|hiit/)) return 'light';
    return null;
  }
  function detectUp(t) {
    if (has(t, /upstairs|first floor|1st floor|\bflat\b(?! (floor|surface|enough))|apartment|shared building|room below|downstairs neighbour|neighbour below|above (a|the|another)|suspended floor/)) return true;
    if (has(t, /ground floor|concrete floor|on concrete|slab/)) return false;
    return null;
  }

  /* ---------- Knowledge answers ---------- */
  var HOURS = 'Mon-Fri 9am-5pm (Saturday by appointment)';
  var TEAM = 'Call <a href="' + TEL + '">' + PHONE + '</a>, <a href="' + WA + '" target="_blank" rel="nofollow noopener">WhatsApp us</a> or email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a>.';

  var TOPICS = [
    { id: 'equip', re: /\b(sell|stock|supply|do you (do|have))\b.*\b(treadmills?|dumbbells?|racks?|benches|bench|barbells?|kettlebells?|equipment|machines?|plates|bikes?|rowers?)\b/,
      a: function () { return 'We are flooring specialists, so we do not sell gym equipment ourselves. What we can do is make sure the floor under it is right: tell me what equipment you have and I will recommend the thickness and product.'; },
      c: [['Help me choose flooring', 'recommend'], ['Thickness guide', 'thickness']] },
    { id: 'human', re: /\b(human|real person|someone|speak|talk to|call (me|you)|phone number|contact|agent|advisor on the phone|ring)\b/,
      a: function () { return 'Our flooring team are on hand ' + HOURS + '. ' + TEAM + ' Messages sent through the <a href="/pages/contact">contact form</a> get a reply within about 2 working hours in office hours.'; },
      c: [['Help me choose flooring', 'recommend'], ['Free samples']] },
    { id: 'samples', re: /sample|swatch|see (it|the rubber) first|feel (it|the)/,
      a: function () { return 'Yes, samples are free. Request them on the <a href="' + SAMPLES + '">free samples page</a>. It is the best way to check thickness, texture and colour before ordering a whole floor.'; },
      c: [['Help me choose flooring', 'recommend'], ['Delivery info', 'delivery']] },
    { id: 'delivery', re: /deliver|shipping|dispatch|postage|courier|pallet|how long.*(arrive|take)|when will|lead time|northern ireland|scotland|highlands|ireland|abroad|overseas|europe/,
      a: function (t) {
        var h = 'Delivery is <b>free on every UK order</b>, with <b>same-day dispatch on orders placed before 2pm</b> (Mon-Fri). We ship from our warehouse in Burnley, Lancashire.';
        if (/ireland|abroad|overseas|europe|outside/.test(t)) h += ' For addresses outside the UK, please get a shipping quote from us before ordering: ' + TEAM;
        else h += ' For an exact delivery date to your postcode or a large pallet order, give the team a quick call on <a href="' + TEL + '">' + PHONE + '</a>.';
        return h;
      }, c: [['Help me choose flooring', 'recommend'], ['Returns policy', 'returns']] },
    { id: 'returns', re: /return|refund|exchange|send (it )?back|change of mind|damaged|faulty|broken/,
      a: function () { return 'Change of mind or exchange: let us know within <b>14 days</b> of receiving your order (return postage is paid by the customer). Damaged or faulty goods: email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> within <b>24 hours</b> of delivery, ideally with photos. Items bought at special discounted prices may not be cancellable. Full details: <a href="/policies/refund-policy">refund policy</a>.'; },
      c: [['Get free samples first', 'samples'], ['Talk to the team', 'human']] },
    { id: 'trade', re: /trade|bulk|wholesale|quote|contractor|architect|specifier|installer|large order|volume|discount|vat invoice|invoice|purchase order|\bpo\b/,
      a: function () { return 'Trade and bulk pricing is available on larger projects, with no obligation. Send your floor plan or area and the type of training to <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> or call <a href="' + TEL + '">' + PHONE + '</a>, ' + HOURS + '. Trade customers can also visit the Burnley warehouse by appointment.'; },
      c: [['Work out quantities', 'calc'], ['Commercial gym advice', 'commercial gym']] },
    { id: 'pay', re: /pay(ment)?|klarna|paypal|finance|credit card|debit card|bank transfer/,
      a: function () { return 'You can pay by credit or debit card at checkout; all available payment options are shown there. UK-issued cards are accepted; customers outside the UK pay by bank transfer after getting a shipping quote.'; },
      c: [['Delivery info', 'delivery'], ['Help me choose flooring', 'recommend']] },
    { id: 'smell', re: /smell|odou?r|fumes|voc|toxic|safe for (kids|children|pets|dogs)|chemical/,
      a: function () { return 'Recycled rubber has a natural rubber smell when new. It fades with ventilation over the first few weeks: unpack the tiles, open windows and let air circulate. If smell is a concern (e.g. a bedroom or small room), the <b>20mm cold-moulded tiles</b> are made with a PU binder and are VOC tested and low odour. All our rubber products are listed as REACH compliant.'; },
      c: [['20mm cold-moulded tiles', 'show cm20'], ['Free samples', 'samples']] },
    { id: 'clean', re: /clean|mop|wash|disinfect|bleach|maintain|maintenance|sweat|chalk|stain/,
      a: function () { return '<b>Cleaning rubber gym flooring:</b><br>1. Vacuum or sweep regularly to remove grit (grit is what wears the surface).<br>2. Damp-mop with warm water and a <b>pH-neutral</b> floor cleaner.<br>3. Avoid bleach, solvents, oil-based or citrus cleaners, polishes and steam mops; they can dry out or discolour rubber.<br>4. Let the floor dry before training on it. For gyms, a daily sweep and weekly mop keeps it looking new.'; },
      c: [['How to install', 'install'], ['Help me choose flooring', 'recommend']] },
    { id: 'cut', re: /cutting|\bcut (the |them|it|tiles?|rubber|around|round|to fit)|how .*\bcut\b|stanley|knife|\btrim/,
      a: function () { return 'Rubber tiles and rolls cut cleanly with a <b>sharp utility (Stanley) knife and a metal straight edge</b>. Score along the line, then make several passes rather than forcing one deep cut; fold the rubber back along the cut to open it up. Change blades often. Mark cuts around doors and pipes with a paper template first.'; },
      c: [['How to install', 'install'], ['Work out quantities', 'calc']] },
    { id: 'glue', re: /glue|adhesive|stick (it )?down|tape|fix (it )?down|bond/,
      a: function () { return 'Interlocking tiles and mats need <b>no adhesive</b>. They lock together and stay put under their own weight, so you can lift them and take them with you. Rolls can be loose-laid in most home gyms; for commercial floors or high-traffic areas, the seams can be taped or the roll bonded with a PU adhesive for a permanent finish.'; },
      c: [['How to install', 'install'], ['Tiles or rolls?', 'tiles vs rolls']] },
    { id: 'ufh', re: /underfloor heating|under ?floor heat|\bufh\b|heated floor/,
      a: function () { return 'Rubber is an insulator, so thick rubber flooring will reduce the output of underfloor heating and some UFH systems have temperature limits for floor coverings. Please check with your heating installer and call us on <a href="' + TEL + '">' + PHONE + '</a> before laying over underfloor heating, so we can advise on the right thickness.'; },
      c: [['Talk to the team', 'human']] },
    { id: 'subfloor', re: /subfloor|concrete|floorboard|floor boards|timber|wooden floor|joist|laminate|vinyl|lino|carpet|tiled floor|ceramic|screed|uneven|damp|moisture|level|flat enough|not flat/,
      a: function (t) {
        var h = '<b>What to lay rubber on:</b><br>';
        if (/carpet/.test(t)) h += '<b>Carpet:</b> take it up first. Tiles laid over carpet move, the joints open up, and heavy equipment sinks. Lay on the floor underneath.<br>';
        if (/vinyl|lino|laminate|ceramic|tiled/.test(t)) h += '<b>Vinyl, laminate or tiled floors:</b> rubber can be laid over firm hard floors. Rubber can mark or discolour some vinyl and light-coloured surfaces over time, so if you want to protect the floor underneath, put down a thin barrier layer (e.g. hardboard) first.<br>';
        if (/floorboard|timber|wooden|joist/.test(t)) h += '<b>Floorboards:</b> fine for most home gyms. If the boards are uneven or springy, screw down a ply sheet first to spread the load. For heavy weights on an upper floor, check the floor can take the load.<br>';
        if (/damp|moisture/.test(t)) h += '<b>Damp:</b> rubber will not fix a damp floor; moisture gets trapped underneath. Sort the damp first (or use a damp-proof membrane) before laying.<br>';
        h += '<b>Concrete or screed</b> is ideal: it just needs to be clean, dry and reasonably level. Interlocking tiles are loose-laid, so no preparation beyond a good sweep is usually needed.';
        return h;
      }, c: [['How to install', 'install'], ['Help me choose flooring', 'recommend']] },
    { id: 'acvhd', re: /acoustic (vs|or|versus) heavy|heavy.?duty (vs|or|versus) acoustic|difference between.*30mm/,
      a: function () { return 'Both are 30mm and 200kg+ drop rated. The <b>Acoustic</b> tile is made to stop impact noise travelling into the building (up to 75dB, 1,000kg/m³), so choose it for upstairs rooms, flats and gyms that share a ceiling. The <b>Heavy-Duty</b> tile is the lifting-platform choice for ground floors, CrossFit boxes and drop zones (90% impact absorption).' + card('a30') + card('t30'); },
      c: [['Work out quantities', 'calc']] },
    { id: 'install', re: /\binstall|\blay(ing)?\b|\bfit(ting)?\b|put (it |them )?down|\bdiy\b|acclimati/,
      a: function () { return '<b>Laying interlocking tiles (tool-free):</b><br>1. Make sure the subfloor is clean, dry, flat and firm.<br>2. Unpack the tiles in the room for 24-48 hours so they settle to room temperature.<br>3. Start from the most visible straight wall or doorway and work outwards, pressing each edge down so the joints lock fully.<br>4. Cut the final row with a sharp utility knife. Leave a small gap at walls in rooms that get hot.<br>5. Add ramped edges where the floor meets a walkway, to prevent trips.<br>A typical home gym takes an afternoon. <b>Rolls:</b> unroll and let them relax flat for 24 hours before trimming to fit.'; },
      c: [['Cutting tips', 'cutting'], ['Do I need glue?', 'glue'], ['What subfloor works?', 'subfloor']] },
    { id: 'noise', re: /noise|noisy|soundproof|sound proof|acoustic|quiet|neighbou?r|decibel|\bdb\b|vibration|upstairs|flat\b|apartment/,
      a: function () {
        return '<b>For upstairs gyms, flats and shared buildings</b> you want density and thickness:<br>' +
          '• <b>30mm Acoustic Tiles</b>: up to 75dB sound reduction (house tested), 200kg+ drop rated.<br>' +
          '• Add the <b>Acoustic Underlay Roll</b> (up to 72dB) underneath for the most sensitive situations, such as a lifting area above a bedroom.<br>' +
          '• For lighter use, the 20mm tiles are rated up to 65dB.<br>' +
          'Honest advice: no floor makes dropped barbells silent upstairs. Use bumper plates, lower weights under control, and for heavy racks or lifting on an upper floor get the floor load checked.' +
          card('a30', 'Our top pick for flats and upstairs rooms') + card('ul', 'Optional extra layer underneath');
      }, c: [['Work out quantities', 'calc'], ['30mm acoustic vs heavy-duty?', 'acoustic vs heavy duty'], ['Talk to the team', 'human']] },
    { id: 'thick', re: /thick|how thick|which mm|\bmm\b.*need|what (size|thickness)/,
      a: function () { return '<b>Thickness guide</b><br>' +
        '• <b>4-8mm rolls:</b> cardio machines, stretching, walkways.<br>' +
        '• <b>12mm:</b> studios, group exercise, light training; EVA foam for yoga, Pilates and kids.<br>' +
        '• <b>16-17mm:</b> most home and garage gyms: dumbbells, machines, general training.<br>' +
        '• <b>20mm:</b> squat racks, barbells and heavy home or commercial weights floors (400kg drop rated).<br>' +
        '• <b>30mm:</b> Olympic lifting, CrossFit drop zones, deadlift platforms; the acoustic version for upstairs rooms.<br>' +
        'Tell me your space and your heaviest lift and I will pick the exact product.'; },
      c: [['Help me choose', 'recommend'], ['Upstairs / flat', 'upstairs home gym']] },
    { id: 'tvr', re: /tiles? (vs|or|versus) rolls?|rolls? (vs|or|versus) tiles?|tile or roll|difference between.*(tile|roll)/,
      a: function () { return '<b>Tiles</b>: tool-free, easy to fit around obstacles, easy to lift, move or replace one damaged tile; the choice for weights areas, home and garage gyms.<br><b>Rolls</b>: seamless coverage, fastest for large rectangular spaces, great under cardio machines and in studios; heavier to handle and best with two people.<br>Many gyms use tiles in the weights area and rolls in the cardio zone.'; },
      c: [['Help me choose', 'recommend'], ['Work out quantities', 'calc']] },
    { id: 'eva', re: /\beva\b|foam/,
      a: function () { return '<b>EVA foam vs rubber:</b> EVA is soft, light and warm underfoot: great for yoga, Pilates, stretching, martial arts drills and kids\' areas. It is <b>not</b> for weights: dumbbells and machines dent it. For anything with weights, choose rubber.' + card('eva', 'Soft, light, quick to lay'); },
      c: [['Rubber for weights', 'home gym dumbbells'], ['Work out quantities', 'calc']] },
    { id: 'drop', re: /drop rat|how much weight|can i drop|drop test|400 ?kg|200 ?kg|weight rating|\bload\b/,
      a: function () { return 'The published ratings: <b>20mm interlocking and 20mm cold-moulded tiles: 400kg rated</b>; <b>30mm heavy-duty and 30mm acoustic tiles: 200kg+ for repeated overhead drops</b>; <b>17mm mats: 200kg drop rated</b>. For Olympic lifting and deliberate drops from overhead, we recommend 30mm in the drop zone and always using bumper plates. Drop ratings protect the floor; they do not make it safe to drop iron plates.'; },
      c: [['Olympic lifting setup', 'olympic lifting garage'], ['Help me choose', 'recommend']] },
    { id: 'cert', re: /certif|en ?13893|\bce\b|\breach\b|\biso\b|slip|fire rat|\br10\b|\bstandards?\b/,
      a: function () { return 'Our rubber tiles, mats and rolls are listed as <b>EN 13893 slip certified</b> and <b>CE and REACH compliant</b>. The 20mm tiles also carry <b>R10 slip resistance (DIN 51130)</b>, an EN 13501 fire rating and ISO 9001 manufacturing. Full specs are on each product page; for certificates for a tender or specification, email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a>.'; },
      c: [['Commercial gym advice', 'commercial gym'], ['Talk to the team', 'human']] },
    { id: 'colour', re: /\bcolou?rs?\b|\bblue\b|\bgr[ae]y\b|\bwhite\b|\bred\b|fleck|speckle|\blogo\b/,
      a: function () { return 'Colour options: <b>12mm tiles</b> in Blue/Black or White/Black fleck; <b>rolls</b> in Black, Red, Blue or White; <b>EVA foam</b> in grey or black (mix them for a checkerboard); <b>17mm mats</b> with yellow or black ramp edges. The 16mm, 20mm and 30mm tiles are black.' + card('t12', 'Best for a coloured studio floor'); },
      c: [['Rolls colours', 'show rolls'], ['Free samples', 'samples']] },
    { id: 'ramps', re: /ramp|edge|bevel|trip|transition|door ?way/,
      a: function () { return 'Matching ramped safety edges are available for the <b>16mm tiles</b>, <b>17mm mats</b> (yellow or black, 1m lengths), <b>30mm heavy-duty tiles</b> and <b>12mm tiles</b> (straight and corner). Select them from the options on each product page. Use them wherever the floor edge meets a walkway.'; },
      c: [['Work out quantities', 'calc']] },
    { id: 'life', re: /how long.*last|lifespan|durab|warrant|guarantee|wear out/,
      a: function () { return 'Our 16mm tiles are rated for a <b>12-15 year commercial lifespan</b>, and the thicker 20mm and 30mm tiles are built for heavier commercial use. For warranty terms on a specific product or a commercial project, please ask the team: ' + TEAM; },
      c: [['Help me choose', 'recommend']] },
    { id: 'outdoor', re: /outdoor|outside|garden|patio|rain|weather|frost|sun|uv/,
      a: function () { return 'For outdoor gyms, the <b>20mm interlocking tiles</b> list UV resistance and a -30°C to +80°C temperature range. Outdoors, rubber needs a firm, free-draining base (e.g. a concrete slab with a fall, or compacted sub-base) so water runs away underneath. Because the base matters so much, please call us on <a href="' + TEL + '">' + PHONE + '</a> before ordering for an outdoor area.' + card('t20', 'UV-resistant spec, 1m² per tile'); },
      c: [['Talk to the team', 'human']] },
    { id: 'weight', re: /how heavy|weigh|kg per tile/,
      a: function () { return 'Tile weights: 16mm tile 4.5kg (500 x 500mm); 20mm cold-moulded tile 9kg (100 x 50cm); EVA foam tile under 1kg. The 1m² 20mm and 30mm tiles are much heavier, so plan for two people when unloading a larger order.'; },
      c: [['How to install', 'install']] },
    { id: 'price', re: /price|cost|how much (is|are|does)|cheap|budget|afford|expensive|per m2|per square/,
      a: function () {
        var rows = [['t16', '16mm tiles'], ['m17', '17mm mats'], ['t20', '20mm interlocking'], ['a30', '30mm acoustic'], ['t30', '30mm heavy-duty'], ['t12', '12mm colour tiles'], ['eva', 'EVA foam']];
        var h = '<b>Current prices per m²</b> (inc. VAT, free UK delivery):<br>';
        rows.forEach(function (r) { if (LIVE[r[0]]) h += '• ' + r[1] + ': ' + perM2(r[0]) + '<br>'; });
        var v = variantFor('rcut', 4); if (v) h += '• Rubber roll, cut to length: from ' + money2(v.p) + ' per metre (1m²)<br>';
        h += 'Most affordable for weights: <b>16mm tiles</b>. Most affordable for cardio: <b>4-6mm roll</b>. Tell me your area and I will give you a total.';
        return h;
      }, c: [['Work out my total', 'calc'], ['Help me choose', 'recommend']] },
    // Broad "do you have / do you do..." catch-all: keep last so specific topics win
    { id: 'range', re: /\b(do you (have|sell|do|stock|make)|what (do you sell|products|sizes)|your range|full range|all products|what sizes?)\b/,
      a: function () {
        return '<b>Our range</b><br>' +
          '<b>Tiles:</b> 16mm (500 x 500mm) · 20mm interlocking (1m x 1m) · 20mm cold-moulded (100 x 50cm) · 30mm heavy-duty and 30mm acoustic (1m x 1m or 500 x 500mm) · 12mm colour-fleck (1m x 1m)<br>' +
          '<b>Mats:</b> 17mm rubber mats (3ft x 3ft) · 12mm EVA foam (610 x 610mm)<br>' +
          '<b>Rolls (1m wide, 4-12mm):</b> cut to length · 10m crumb · 10m smooth · acoustic underlay<br>' +
          'Ask about any of them, or let me pick the right one for your space.';
      }, c: [['Help me choose', 'recommend'], ['Prices', 'price'], ['Thickness guide', 'thickness']] }
  ];

  var PRODUCT_WORDS = [
    [/16 ?mm/, 't16'], [/17 ?mm|3 ?ft (x )?3 ?ft|gym mats?\b/, 'm17'], [/cold.?mou?ld|titan/, 'cm20'], [/20 ?mm/, 't20'],
    [/acoustic tile|30 ?mm acoustic/, 'a30'], [/30 ?mm|heavy.?duty tile/, 't30'], [/12 ?mm tile|colour tile/, 't12'],
    [/underlay/, 'ul'], [/crumb/, 'r10'], [/cut to length|per metre|roll/, 'rcut']
  ];

  /* ---------- Recommendation engine ---------- */
  function recommend() {
    var sp = S.space, act = S.act, up = S.up;
    var r = { main: null, mainWhy: '', mm: null, alts: [], note: '' };

    if (sp === 'outdoor') { r.main = 't20'; r.mainWhy = 'Spec lists UV resistance and -30°C to +80°C'; r.note = 'Outdoors the base is critical (firm and free-draining). Please call us before ordering.'; return r; }
    if (up && (act === 'drop' || act === 'barbell')) {
      r.main = 'a30'; r.mainWhy = 'Up to 75dB sound reduction and 200kg+ drop rated: the right tile above another room';
      r.alts = [['ul', 'Add underneath the lifting area for extra isolation']];
      r.note = 'Use bumper plates and lower weights under control. For a heavy rack or lifting upstairs, get the floor load checked.';
      return r;
    }
    if (up) {
      r.main = 'a30'; r.mainWhy = 'Best at stopping impact noise reaching the room below';
      r.alts = [['t20', 'Lighter use and a tighter budget: up to 65dB']];
      return r;
    }
    if (sp === 'soft' && act !== 'dumbbell' && act !== 'barbell' && act !== 'drop') {
      r.main = 'eva'; r.mainWhy = 'Soft, warm and light: made for mat work and bodyweight training';
      r.alts = [['t12', 'If the space also takes equipment: a firmer rubber floor in colour']];
      r.note = 'EVA foam is not suitable for weights.';
      return r;
    }
    if (act === 'drop') {
      r.main = 't30'; r.mainWhy = '200kg+ drop rated for repeated overhead drops: use it for the platform or drop zone';
      r.alts = [['t20', 'Rest of the floor: 400kg rated, 1m² tiles']];
      r.note = 'Most boxes and garage lifters put 30mm where the bar lands and 20mm everywhere else. Always use bumper plates.';
      return r;
    }
    if (act === 'barbell') {
      r.main = 't20'; r.mainWhy = '400kg rated, self-locking 1m² tiles: the go-to under a rack and barbell';
      r.alts = [['t30', 'Add a 30mm zone if you will drop deadlifts or cleans'], ['cm20', 'Premium, low-odour alternative (100 x 50cm)']];
      return r;
    }
    if (act === 'dumbbell') {
      if (sp === 'commercial' || sp === 'studio') {
        r.main = 't20'; r.mainWhy = 'Commercial weights floors: 400kg rated, R10 slip resistance';
        r.alts = [['t16', 'Lower-cost option for lighter zones'], ['t12', 'Colour-fleck finish for studios']];
      } else {
        r.main = 't16'; r.mainWhy = 'Best value weights floor: 70% impact absorption, easy 500mm tiles';
        r.alts = [['t20', 'Step up if you might add a squat rack later'], ['m17', 'Bigger 3ft x 3ft mats, 200kg drop rated']];
      }
      return r;
    }
    if (act === 'light') {
      if (sp === 'commercial' || sp === 'cardio') {
        r.main = 'rsm'; r.mm = 8; r.mainWhy = 'Seamless 10m² rolls for cardio floors and studios';
        r.alts = [['rcut', 'Cut to your exact length', 6], ['t12', 'Colour-fleck tiles for a studio look']];
      } else if (sp === 'soft') {
        r.main = 'eva'; r.mainWhy = 'Soft and comfortable for mat work';
      } else {
        r.main = 'rcut'; r.mm = 8; r.mainWhy = 'One seamless piece under a treadmill, bike or rower';
        r.alts = [['t16', 'If you will also use dumbbells']];
      }
      return r;
    }
    return null;
  }

  function quantity(key, mm) {
    var info = INFO[key], v = variantFor(key, mm), a = S.area, d = S.dims;
    if (!a || !v) return null;
    var qty, text;
    if (key === 'rcut') {
      if (d) {
        var runsA = Math.ceil(d[0] - 0.02) * d[1], runsB = Math.ceil(d[1] - 0.02) * d[0];
        qty = Math.ceil(Math.min(runsA, runsB));
        text = qty + ' metres (1m-wide strips across the room)';
      } else { qty = Math.ceil(a * 1.05); text = 'about ' + qty + ' metres'; }
    } else if (info.roll) {
      qty = Math.ceil((a * 1.05) / info.cov);
      text = qty + ' x 10m roll' + (qty > 1 ? 's' : '');
    } else {
      qty = Math.ceil((a * 1.08) / info.cov);
      text = qty + ' ' + info.unit + 's';
    }
    return { qty: qty, text: text, total: qty * v.p, v: v };
  }

  function showRecommendation() {
    var r = recommend();
    if (!r) return false;
    var spaceName = { home: 'home gym', garage: 'garage gym', commercial: 'commercial gym', studio: 'studio', soft: 'studio', cardio: 'cardio area', outdoor: 'outdoor area' }[S.space] || 'space';
    var h = '<b>My recommendation for your ' + spaceName + ':</b>' + card(r.main, r.mainWhy, { mm: r.mm });
    var q = quantity(r.main, r.mm);
    if (q) {
      h += '<div class="gfa-quote"><div><span>Area</span><b>' + (S.dims ? S.dims.map(function (n) { return +n.toFixed(2); }).join(' x ') + 'm = ' : '') + (+S.area.toFixed(1)) + 'm²</b></div>' +
        '<div><span>You need</span><b>' + q.text + '</b></div>' +
        '<div><span>Estimated total</span><b>' + money2(q.total) + '</b></div>' +
        '<small>' + (INFO[r.main].roll ? 'Based on the ' + (r.mm || '') + (r.mm ? 'mm ' : '') + 'option. ' : 'Includes ~8% extra for cuts. ') + 'Inc. VAT, free UK delivery.</small>' +
        '<button type="button" class="gfa-add" data-v="' + q.v.id + '" data-q="' + q.qty + '">Add ' + q.qty + ' to basket</button></div>';
    }
    if (r.alts.length) {
      h += '<div class="gfa-alt-h">Also worth considering</div>';
      r.alts.forEach(function (a) { h += card(a[0], a[1], { mm: a[2] }); });
    }
    if (r.note) h += '<div class="gfa-note">' + r.note + '</div>';
    bot(h);
    var c = [];
    if (!S.area) c.push(['Add my room size', 'calc']);
    c.push(['Get free samples', 'samples'], ['How to install', 'install'], ['Talk to the team', 'human'], ['Start again', 'restart']);
    setChips(c);
    return true;
  }

  /* ---------- Guided flow ---------- */
  function askSpace() {
    bot('What are you flooring?');
    setChips([['Home gym', 'home gym'], ['Garage gym', 'garage gym'], ['Upstairs room / flat', 'upstairs home gym'], ['Commercial gym', 'commercial gym'], ['CrossFit / PT studio', 'crossfit box'], ['Yoga, martial arts or kids', 'yoga studio'], ['Cardio area', 'cardio area'], ['Outdoor', 'outdoor gym']]);
  }
  function askAct() {
    bot('What is the heaviest training that will happen on it?');
    setChips([['Cardio & bodyweight', 'cardio machines'], ['Dumbbells & machines', 'dumbbells and machines'], ['Barbell & squat rack', 'squat rack and barbell'], ['Olympic lifts / dropping weights', 'olympic lifting drops']]);
  }
  function askUp() {
    S.asked.up = true;
    bot('Is there a room below the gym (upstairs, a flat, or a shared building)?');
    setChips([['Yes, there is a room below', 'upstairs'], ['No, ground floor / concrete', 'ground floor']]);
  }
  function askArea() {
    S.asked.area = true;
    bot('How big is the area? Type the room size, e.g. <b>4 x 3m</b>, <b>12 x 10ft</b> or <b>20m²</b>, and I will work out exactly how much you need and the total cost.');
    setChips([['Skip, just show me', 'skip size']]);
  }
  function next() {
    if (!S.space) return askSpace();
    if (!S.act && S.space !== 'outdoor') return askAct();
    if (S.up === null && !S.asked.up && (S.space === 'home' || S.space === 'studio' || S.space === 'commercial') && S.act !== 'light') return askUp();
    if (!S.area && !S.asked.area) return askArea();
    showRecommendation();
  }

  /* ---------- Message handler ---------- */
  function handle(text, label) {
    if (!text) return;
    if (text === 'restart') { reset(); return; }
    if (aiOn()) { askAI(label || text); return; }
    user(label || text);
    chips.innerHTML = '';
    typing(function () { respond(text); });
  }

  /* ---------- Claude (via the Cloudflare Worker in data-ai) ---------- */
  // The Worker holds the API key and the product catalogue; see worker/gf-flooring-specialist.js.
  var AI_URL = '', aiDown = false, busy = false;
  function aiOn() { return !!AI_URL && !aiDown; }

  function renderMd(src) {
    var lines = esc(src).split('\n'), out = '', list = '';
    function closeList() { if (list) { out += '</' + list + '>'; list = ''; } }
    lines.forEach(function (ln) {
      var m;
      if ((m = ln.match(/^\s*[-•*]\s+(.*)$/))) { if (list !== 'ul') { closeList(); out += '<ul>'; list = 'ul'; } out += '<li>' + m[1] + '</li>'; return; }
      if ((m = ln.match(/^\s*\d+[.)]\s+(.*)$/))) { if (list !== 'ol') { closeList(); out += '<ol>'; list = 'ol'; } out += '<li>' + m[1] + '</li>'; return; }
      closeList();
      if (ln.trim()) out += '<p>' + ln + '</p>';
    });
    closeList();
    return out
      .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>')
      .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (all, t, u) {
        var href = u.replace(/&amp;/g, '&');
        var ok = /^\/(?!\/)/.test(href) || /^https:\/\/(www\.)?gymflooringuk\.uk\//.test(href) || /^tel:|^mailto:sales@gymflooringuk\.uk$|^https:\/\/wa\.me\/447822012977/.test(href);
        if (!ok) return t;
        var ext = /^https:\/\/wa\.me/.test(href);
        return '<a href="' + esc(href) + '"' + (ext ? ' target="_blank" rel="nofollow noopener"' : '') + '>' + t + '</a>';
      });
  }

  function keyForHandle(h) {
    for (var k in LIVE) { if (LIVE[k].url === '/products/' + h) return k; }
    return null;
  }
  function findVariant(id) {
    for (var k in LIVE) {
      var v = LIVE[k].v.filter(function (x) { return String(x.id) === String(id); })[0];
      if (v) return { key: k, v: v };
    }
    return null;
  }
  function quoteHtml(id, qty) {
    var f = findVariant(id);
    qty = Math.max(1, Math.min(999, parseInt(qty, 10) || 1));
    if (!f) return '';
    var p = LIVE[f.key];
    return '<div class="gfa-quote">' +
      '<div><span>Product</span><b><a href="' + p.url + '?variant=' + f.v.id + '">' + esc(INFO[f.key].name) + '</a></b></div>' +
      (f.v.t && f.v.t !== 'Default Title' ? '<div><span>Option</span><b>' + esc(f.v.t) + '</b></div>' : '') +
      '<div><span>Quantity</span><b>' + qty + ' x ' + money2(f.v.p) + '</b></div>' +
      '<div><span>Total</span><b>' + money2(f.v.p * qty) + '</b></div>' +
      '<small>Inc. VAT, free UK delivery.</small>' +
      (f.v.a === false ? '<small>This option is currently unavailable online; please call us.</small>' :
        '<button type="button" class="gfa-add" data-v="' + f.v.id + '" data-q="' + qty + '">Add ' + qty + ' to basket</button>') +
      '</div>';
  }

  // Split a finished reply into text + tag blocks; tags only ever produce known products/variants.
  function renderReply(text) {
    var extras = '', chipList = null, note = '';
    var body = text.replace(/\[\[(product|quote|chips|refusal|error)(?::([^\]]*))?\]\]/g, function (all, kind, arg) {
      arg = arg || '';
      if (kind === 'product') { var k = keyForHandle(arg.trim()); if (k) extras += card(k); }
      else if (kind === 'quote') { var bits = arg.split(':'); extras += quoteHtml(bits[0], bits[1]); }
      else if (kind === 'chips') { chipList = arg.split('|').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4); }
      else note = 'Sorry, I can\'t help with that one here. Our team can: ' + TEAM;
      return '';
    });
    return { html: renderMd(body.replace(/\[\[[^\]]*$/, '').trim()) + extras + (note ? '<p>' + note + '</p>' : ''), chips: chipList };
  }

  // text is what Claude receives; shown is what the customer sees (e.g. without the product prefix).
  function askAI(text, shown) {
    if (busy) return;
    if (S.convo.length >= 38) {
      user(shown || text);
      bot('This conversation is getting long. Tap restart (top right) to start a fresh one, or call the team on <a href="' + TEL + '">' + PHONE + '</a>.');
      return;
    }
    busy = true;
    unlockAudio(); // runs inside the customer's tap, so Hugo can speak when the reply lands
    user(shown || text);
    chips.innerHTML = '';
    var sent = text;
    if (!S.convo.length && document.title) sent = '[Customer is on the page: ' + document.title.replace(/\s+/g, ' ').slice(0, 120) + ']\n' + text;
    var msgs = S.convo.concat([{ role: 'user', content: sent }]);

    var el = document.createElement('div');
    el.className = 'gfa-msg gfa-msg--bot gfa-typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    log.appendChild(el); log.scrollTop = log.scrollHeight;
    setTypingNote(true);

    // Reveal the streamed text at a steady reading pace rather than in bursts, so it
    // reads like someone typing. Tags ([[...]]) never show while streaming.
    var full = '', shown = 0, streamDone = false, started = Date.now(), finish = null;
    var CPS_FRAME = 3; // characters per animation frame (~180/s)
    function visibleText() { return full.replace(/\[\[[^\]]*\]\]/g, '').replace(/\[\[[^\]]*$/, '').trim(); }
    function tick() {
      var target = visibleText();
      if (target && Date.now() - started > 150) {
        if (shown < target.length) {
          shown = Math.min(target.length, shown + CPS_FRAME + Math.floor((target.length - shown) / 120));
          el.className = 'gfa-msg gfa-msg--bot';
          el.innerHTML = renderMd(target.slice(0, shown));
          log.scrollTop = log.scrollHeight;
        }
      }
      if (streamDone && shown >= target.length) { if (finish) finish(); return; }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    var caughtUp = new Promise(function (res) { finish = res; });
    // Speak while the reply is still arriving: first sentence as soon as it exists.
    var voiceStream = (voiceOn && ttsUrl) ? startSpeechStream() : null;

    window.fetch(AI_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: msgs }) })
      .then(function (r) {
        if (!r.ok || !r.body) throw new Error('status ' + r.status);
        var reader = r.body.getReader(), dec = new TextDecoder();
        function pump() {
          return reader.read().then(function (res) {
            if (res.done) return;
            full += dec.decode(res.value, { stream: true });
            if (voiceStream) voiceStream.feed(visibleText(), false);
            return pump();
          });
        }
        return pump();
      })
      .then(function () {
        streamDone = true;
        if (!full.trim()) throw new Error('empty');
        if (voiceStream) voiceStream.feed(visibleText(), true);
        return caughtUp;
      })
      .then(function () {
        setTypingNote(false);
        var out = renderReply(full);
        el.className = 'gfa-msg gfa-msg--bot';
        el.innerHTML = out.html;
        history.push({ who: 'bot', html: out.html });
        S.convo = msgs.concat([{ role: 'assistant', content: full.trim() }]);
        setChips((out.chips || []).map(function (c) { return [c, c]; }).concat(S.convo.length > 2 ? [['Prefer a person? Call the team', 'Can I speak to someone on the team?']] : []));
        log.scrollTop = log.scrollHeight;
        if (!voiceStream) speak(full);
      })
      .catch(function () {
        // Worker unreachable or failed: answer with the built-in advisor for the rest of this page view.
        if (voiceStream) stopVoice();
        streamDone = true; full = ''; setTypingNote(false);
        el.remove();
        aiDown = true;
        typing(function () { respond(text); });
      })
      .then(function () { busy = false; save(); });
  }

  function respond(raw) {
    var t = ' ' + raw.toLowerCase().replace(/[’']/g, "'") + ' ';

    if (/^ ?(restart|start again|start over|reset) ?$/.test(t)) { reset(); return; }
    if (/^ ?(hi|hello|hey|hiya|morning|afternoon)[ !.]*$/.test(t)) { bot('Hello! I can recommend the right flooring, work out quantities and costs, and answer questions on installation, delivery and more.'); next(); return; }
    if (/thank|cheers|great|perfect|brilliant|lovely|that's all/.test(t) && t.length < 40 && t.indexOf('?') < 0) {
      bot('You are welcome! If you want a second opinion before ordering, our team is on ' + PHONE + ', ' + HOURS + '.');
      setChips([['Get free samples', 'samples'], ['Start again', 'restart']]); return;
    }
    if (/^ ?skip size ?$/.test(t)) { S.asked.area = true; if (!showRecommendation()) next(); return; }
    if (/^ ?recommend ?$/.test(t) || /help me choose|what (flooring|floor) (do|should)|recommend|which (flooring|product|tile) /.test(t)) {
      if (!showRecommendationIfReady()) next(); return;
    }
    if (/^ ?calc ?$/.test(t)) { S.asked.area = false; askArea(); return; }
    var sm = t.match(/^ ?show (\w+) ?$/);
    if (sm) {
      if (sm[1] === 'rolls') { bot('Our rolls:' + card('rcut', 'Any length, 4-12mm') + card('r10', 'Crumb finish, 10m²') + card('rsm', 'Smooth finish, 10m²')); setChips([['Tiles or rolls?', 'tiles vs rolls'], ['Work out quantities', 'calc']]); return; }
      if (INFO[sm[1]]) { bot(card(sm[1], INFO[sm[1]].spec)); setChips([['Work out quantities', 'calc'], ['Help me choose', 'recommend']]); return; }
    }

    // Gather context from the message
    var size = parseSize(t), sp = detectSpace(t), act = detectAct(t), up = detectUp(t);
    if (size) { S.area = size.area; S.dims = size.dims; }
    if (sp) S.space = sp;
    if (act) S.act = act;
    if (up !== null) S.up = up;
    if (up === true && !S.space) S.space = 'home'; // "upstairs flat" is a home gym unless they say otherwise
    if (sp === 'soft' && !act) S.act = 'light';
    if (sp === 'cardio' && !act) S.act = 'light';
    if (/^ ?(upstairs|ground floor) ?$/.test(t) || (up !== null && !sp && !act && !size)) { S.asked.up = true; next(); return; }

    // Knowledge questions first (unless the message was only context)
    var topic = null;
    for (var i = 0; i < TOPICS.length; i++) { if (TOPICS[i].re.test(t)) { topic = TOPICS[i]; break; } }
    var isQuestion = /\?|^ ?(how|what|which|can|do|does|is|are|will|should|where|when|why)\b/.test(t);

    var context = !!(sp || act || size);
    if (/how (much|many)\b.*\b(need|buy|order|get)\b|quantit|how many (tiles|mats|rolls|metres)/.test(t) && !size) {
      if (S.area && S.space) { showRecommendation(); } else { S.asked.area = false; if (!S.space) { bot('Happy to work that out.'); next(); } else askArea(); }
      return;
    }
    if (topic && topic.id === 'range') {
      // "do you have 16mm tiles?" -> show that product rather than the whole range
      for (var r = 0; r < PRODUCT_WORDS.length; r++) {
        if (PRODUCT_WORDS[r][0].test(t)) { topic = null; break; }
      }
    }
    if (topic) {
      if (topic.id === 'noise') S.up = true;
      // "20m2 garage gym with a rack" is context for a recommendation, not a price/thickness question
      var flowy = /^(noise|trade|price|thick|drop|eva)$/.test(topic.id);
      if (!(context && flowy && !isQuestion)) {
        bot(topic.a(t));
        if (context) next(); else setChips(topic.c);
        return;
      }
    }

    // Specific product mentioned with a question
    if (!sp && !act && !size) {
      for (var j = 0; j < PRODUCT_WORDS.length; j++) {
        if (PRODUCT_WORDS[j][0].test(t)) {
          var k = PRODUCT_WORDS[j][1];
          bot('<b>' + INFO[k].name + '</b>: ' + INFO[k].spec + '.' + card(k));
          setChips([['Is it right for me?', 'recommend'], ['Work out quantities', 'calc'], ['Free samples', 'samples']]);
          return;
        }
      }
    }

    if (size && S.space && (S.act || S.space === 'outdoor')) {
      if (size.unitless) bot('I have taken ' + size.dims.join(' x ') + ' as metres. Type "' + size.dims.join(' x ') + ' ft" if you meant feet.');
      S.asked.area = true; showRecommendation(); return;
    }
    if (size && !S.space) { bot('Got it: ' + (+S.area.toFixed(1)) + 'm². ' + (size.unitless ? '(I have taken that as metres.) ' : '')); next(); return; }
    if (sp || act || size || up !== null) { next(); return; }

    // Nothing matched
    bot('I am not certain about that one, and I would rather not guess. Our flooring team can answer it properly, ' + HOURS + ': ' + TEAM);
    setChips([['Help me choose flooring', 'recommend'], ['Thickness guide', 'thickness'], ['Prices', 'price'], ['Delivery', 'delivery']]);
  }

  function showRecommendationIfReady() {
    if (S.space && (S.act || S.space === 'outdoor') && (S.area || S.asked.area)) return showRecommendation();
    return false;
  }

  /* ---------- Add to basket ---------- */
  function addToCart(btn) {
    var id = +btn.getAttribute('data-v'), q = +btn.getAttribute('data-q');
    btn.disabled = true; btn.textContent = 'Adding...';
    // Plain string URL so snippets/storefront-tracking.liquid records add_to_cart.
    window.fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: q }] })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      btn.textContent = 'Added, going to basket...';
      save();
      window.location.href = '/cart';
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Try again';
      bot('Sorry, that did not add to your basket. Please use the product link above, or call us on ' + PHONE + '.');
    });
  }

  /* ---------- Open / close ---------- */
  function status() {
    var open = false;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
      var wd = '', hr = 0;
      parts.forEach(function (p) { if (p.type === 'weekday') wd = p.value; if (p.type === 'hour') hr = +p.value; });
      open = /Mon|Tue|Wed|Thu|Fri/.test(wd) && hr >= 9 && hr < 17;
    } catch (e) {}
    document.getElementById('gfaDot').className = 'gfa__dot is-on';
    // Keep "AI" here: with no tag and no mention in the greeting this is the only place the chat says so.
    statusText = aiOn() ? 'AI flooring adviser · replies in seconds' : (open ? 'Flooring team · available now' : 'Flooring team · back Mon-Fri 9-5');
    document.getElementById('gfaStatus').textContent = statusText;
  }
  var statusText = '';
  function setTypingNote(on) {
    var s = document.getElementById('gfaStatus');
    if (s) s.textContent = on ? 'Hugo is typing…' : statusText;
  }
  function welcome(brief) {
    if (aiOn() && brief) {
      bot('Hi, I\'m Hugo from Gym Flooring UK. Let me take a look at that for you.');
      return;
    }
    if (aiOn()) {
      bot('Hi, I\'m Hugo, the flooring adviser here at Gym Flooring UK. Our flooring team are on hand too if you\'d rather speak to a person.');
      bot('What are you kitting out: a home gym, a garage, a studio? Tell me a bit about it (the kit, the room size, what\'s underneath) and I\'ll point you to the right floor and work out exactly what you\'ll need.');
      setChips([['Home gym'], ['Garage gym'], ['Upstairs room or flat'], ['Commercial gym'], ['CrossFit or PT studio'], ['Yoga or martial arts'], ['Cardio area']]);
      return;
    }
    bot('Hi, I am the Gym Flooring UK flooring specialist. Tell me about your space and I will recommend the right floor, work out how much you need and what it costs. You can also ask me anything about thickness, installation, noise or delivery.');
    askSpace();
  }
  function reset() {
    stopVoice();
    S = { space: null, act: null, up: null, area: null, dims: null, sub: null, asked: {}, convo: [] };
    history = []; log.innerHTML = ''; chips.innerHTML = '';
    welcome(); save();
  }
  // msg: optional question to send straight away. source: where it was opened from (for analytics).
  // context: optional prefix Claude sees but the customer doesn't (e.g. which product page).
  function open(msg, source, context) {
    var wasHidden = panel.hidden;
    panel.hidden = false; launch.setAttribute('aria-expanded', 'true'); launch.classList.add('is-open');
    document.documentElement.classList.add('gfa-is-open');
    requestAnimationFrame(function () { panel.classList.add('is-in'); });
    status();
    var fresh = !log.children.length;
    if (fresh) welcome(!!msg);
    // Voice is on by default. Opening the chat is a click, so this is the first moment the
    // browser allows sound: unlock it and read the greeting (a question, if any, is read when answered).
    if (voiceOn && source !== 'restore') {
      unlockAudio();
      if (fresh && !msg) {
        var greet = [].map.call(log.querySelectorAll('.gfa-msg--bot'), function (m) { return m.innerText; }).join(' ');
        setTimeout(function () { speak(greet); }, 350);
      }
    }
    setTimeout(function () { if (window.matchMedia('(min-width: 750px)').matches) input.focus(); log.scrollTop = log.scrollHeight; }, 30);
    if (wasHidden) track(msg ? 'ask' : 'open', source);
    if (msg) {
      if (aiOn()) askAI(context ? context + msg : msg, msg);
      else handle(msg);
    }
    save();
  }
  function close() {
    stopVoice();
    endConvo();
    if (rec && rec.form.id === 'gfaForm') { rec.silent = true; stopMic(); }
    panel.classList.remove('is-in');
    panel.hidden = true; launch.setAttribute('aria-expanded', 'false'); launch.classList.remove('is-open');
    document.documentElement.classList.remove('gfa-is-open');
    save();
  }
  function toggle() { panel.hidden ? open(null, 'toggle') : close(); }

  // Engagement events for GTM (custom event, no personal data). storefront-tracking's
  // consent queue doesn't apply to these; GTM decides what, if anything, fires on them.
  function track(action, source) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'gf_specialist', gf_action: action, gf_source: source || 'unknown' }); } catch (e) {}
  }

  /* ---------- Voice: Hugo reads his replies aloud (browser speech, opt-in) ---------- */
  // Uses the device's own text-to-speech, so the voice differs by device. Off until the
  // customer taps the speaker (browsers block unprompted audio); the choice is remembered.
  var VOICE_KEY = 'gfa_voice_v1', voiceOn = false, voiceBtn = null, pickedVoice = null;
  function voiceSupported() { return !!(window.speechSynthesis && window.SpeechSynthesisUtterance); }
  function chooseVoice() {
    if (pickedVoice) return pickedVoice;
    var vs = window.speechSynthesis.getVoices() || [];
    if (!vs.length) return null;
    var gb = vs.filter(function (v) { return /en[-_]GB/i.test(v.lang); });
    // British male voices, best-sounding first (Edge/Windows natural, Google, Apple).
    var prefs = [/Ryan.*Natural/i, /Thomas.*Natural/i, /(Oliver|Elliot|Ethan|Noah|Alfie).*Natural/i, /Microsoft (Ryan|George|Thomas)/i,
      /Google UK English Male/i, /^Daniel\b/i, /^Arthur\b/i, /^Oliver\b/i, /male/i];
    for (var i = 0; i < prefs.length; i++) {
      var hit = gb.filter(function (v) { return prefs[i].test(v.name); })[0];
      if (hit) return (pickedVoice = hit);
    }
    return (pickedVoice = gb[0] || vs.filter(function (v) { return /^en/i.test(v.lang); })[0] || null);
  }
  // Numbers as a British person says them ("twenty", "five hundred and nineteen"). The voice
  // model sometimes reads digits glued to units or dashes ("20mm", "16-20mm") as "two zero",
  // so every number is written out in words before it is spoken.
  var ONES = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve',
    'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  var TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  function words(n) {
    n = Math.floor(n);
    if (n < 20) return ONES[n];
    if (n < 100) return TENS[Math.floor(n / 10)] + (n % 10 ? '-' + ONES[n % 10] : '');
    if (n < 1000) return ONES[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' and ' + words(n % 100) : '');
    if (n < 1000000) {
      var r = n % 1000;
      return words(Math.floor(n / 1000)) + ' thousand' + (r ? (r < 100 ? ' and ' : ' ') + words(r) : '');
    }
    return String(n);
  }
  function numWords(s) {
    s = String(s).replace(/,/g, '');
    var p = s.split('.');
    var w = words(parseInt(p[0], 10) || 0);
    if (p[1]) w += ' point ' + p[1].split('').map(function (d) { return ONES[+d]; }).join(' ');
    return w;
  }
  var UNITS = { mm: ['millimetre', 'millimetres'], cm: ['centimetre', 'centimetres'], m: ['metre', 'metres'],
    kg: ['kilo', 'kilos'], ft: ['foot', 'feet'], dB: ['decibel', 'decibels'], db: ['decibel', 'decibels'] };
  // Units are marked here and worded at the end of spoken(), once the next word is known:
  // "20mm tiles" -> "twenty millimetre tiles", but "20mm thick" -> "twenty millimetres thick".
  function unitWord(u, n) { return UNITS[u] ? '\u0001' + u + '\u0003' + (parseFloat(n) === 1 ? 's' : 'p') + '\u0002' : u; }
  var KEEP_PLURAL = /^(long|wide|thick|deep|high|tall|of|and|to|in|on|at|for|per|by|is|are|was|were|will|would|should|could|can|each|apart|away|plus|total|overall|across|with|from|so|but|then|which|that|if|than|as|you|we|it|this|these|there|down|up|off|either|both|all|would|just|only)$/i;
  function unitWords(t) {
    return t.replace(/\u0001(\w+)\u0003([sp])\u0002(?=\s+([A-Za-z]+)|)/g, function (m, u, one, next) {
      return UNITS[u][one === 's' || (next && !KEEP_PLURAL.test(next)) ? 0 : 1];
    });
  }
  var NUM = '(\\d[\\d,]*(?:\\.\\d+)?)';

  // Text as it should be heard: no tags, markdown, links, symbols or bare digits.
  function spoken(text) {
    var t = String(text)
      .replace(/\[\[[^\]]*\]\]/g, ' ')
      .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
      .replace(/\*\*/g, '')
      .replace(/^\s*[-•*]\s+/gm, '');
    // Phone numbers: digit by digit, in groups ("oh one two eight two, two seven seven, ...").
    t = t.replace(/\b0\d{3,4}[\s-]?\d{3}[\s-]?\d{3,4}\b/g, function (m) {
      return m.split(/[\s-]+/).map(function (g) { return g.split('').map(function (d) { return d === '0' ? 'oh' : ONES[+d]; }).join(' '); }).join(', ');
    });
    // Money: £519.60 -> five hundred and nineteen pounds sixty
    t = t.replace(/£(\d[\d,]*)(?:\.(\d\d))?/g, function (m, p, d) {
      var n = parseInt(p.replace(/,/g, ''), 10);
      return words(n) + (n === 1 ? ' pound' : ' pounds') + (d && d !== '00' ? ' ' + words(+d) : '');
    });
    // Square metres and ratings
    t = t.replace(new RegExp(NUM + '\\s*m²', 'g'), function (m, n) { return numWords(n) + (parseFloat(n) === 1 ? ' square metre' : ' square metres'); })
      .replace(/m²/g, 'square metres')
      .replace(new RegExp(NUM + '\\s*kg\\/m³', 'g'), function (m, n) { return numWords(n) + ' kilos per cubic metre'; })
      .replace(new RegExp(NUM + '\\s*%', 'g'), function (m, n) { return numWords(n) + ' percent'; });
    // Ranges with units: 16-20mm / 4 to 12mm -> sixteen to twenty millimetres
    t = t.replace(new RegExp(NUM + '\\s*(?:-|–|to)\\s*' + NUM + '\\s*(mm|cm|m|kg|ft|dB|db)\\b', 'g'), function (m, a, b, u) {
      return numWords(a) + ' to ' + numWords(b) + ' ' + unitWord(u, b);
    });
    // Dimensions: 1000x500x20mm, 500 x 500mm, 4m x 3m -> "four by three metres"
    var DIM = NUM + '\\s*(mm|cm|m|ft)?\\s*[x×]\\s*';
    t = t.replace(new RegExp(DIM + DIM + NUM + '\\s*(mm|cm|m|ft)?\\b', 'g'), function (m, a, ua, b, ub, c, uc) {
      var u = uc || ub || ua;
      return numWords(a) + (ua && ua !== u ? ' ' + unitWord(ua, a) : '') + ' by ' + numWords(b) + (ub && ub !== u ? ' ' + unitWord(ub, b) : '') +
        ' by ' + numWords(c) + (u ? ' ' + unitWord(u, c) : '');
    });
    t = t.replace(new RegExp(DIM + NUM + '\\s*(mm|cm|m|ft)?\\b', 'g'), function (m, a, ua, b, ub) {
      var u = ub || ua;
      return numWords(a) + (ua && ua !== u ? ' ' + unitWord(ua, a) : '') + ' by ' + numWords(b) + (u ? ' ' + unitWord(u, b) : '');
    });
    // Single measurements: 20mm, 1m, 25kg, 75dB, 200kg+
    t = t.replace(new RegExp(NUM + '\\s*(mm|cm|m|kg|ft|dB|db)\\b(\\+)?', 'g'), function (m, n, u, plus) {
      return numWords(n) + ' ' + unitWord(u, n) + (plus ? ' plus' : '');
    });
    // Plain number ranges and anything left: 5-10 tiles, 53 tiles, 1,000
    t = t.replace(new RegExp(NUM + '\\s*(?:-|–)\\s*' + NUM, 'g'), function (m, a, b) { return numWords(a) + ' to ' + numWords(b); })
      .replace(new RegExp(NUM + '(\\+)?', 'g'), function (m, n, plus) { return numWords(n) + (plus ? ' plus' : ''); });
    return unitWords(t).replace(/\s+/g, ' ').trim();
  }
  function chunkText(text, max) {
    var parts = spoken(text).match(/[^.!?]+[.!?]*\s*/g) || [];
    var chunks = [], cur = '';
    parts.forEach(function (p) { if ((cur + p).length > max && cur) { chunks.push(cur.trim()); cur = ''; } cur += p; });
    if (cur.trim()) chunks.push(cur.trim());
    return chunks;
  }

  // Premium voice: Deepgram Aura-2 ("draco", British male) via the Worker's /tts, same for
  // every visitor. One <audio> element is reused so the tap that turns voice on also
  // unlocks playback on iPhone. If /tts is unavailable Hugo stays silent (no robot voice).
  var ttsUrl = '', audioEl = null, playSeq = 0;
  var SILENT_WAV = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';
  function ensureAudio() {
    if (!audioEl) { audioEl = new Audio(); audioEl.preload = 'auto'; }
    return audioEl;
  }
  // The <audio> element streams GET /tts?t=... and starts playing after the first few hundred
  // milliseconds of audio, instead of waiting for the whole sentence to download.
  function fetchSpeech(text) {
    return Promise.resolve(ttsUrl + '?t=' + encodeURIComponent(text));
  }
  // Streaming speech for a reply that is still arriving. feed() is called with the visible
  // text so far; whole sentences are cut off and sent to /tts straight away (all chunks are
  // fetched in parallel), then played in order. The first chunk is kept short so Hugo starts
  // talking within a second or two of the first sentence appearing.
  function startSpeechStream() {
    stopVoice();
    var seq = playSeq, a = ensureAudio(), queue = [], playing = false, taken = 0, finalFed = false;
    function playNext() {
      if (seq !== playSeq) return;
      var p = queue.shift();
      if (!p) { playing = false; if (finalFed) spokenReplyDone(); return; }
      playing = true;
      p.then(function (src) {
        if (seq !== playSeq) return;
        var moved = false;
        function advance() { if (!moved) { moved = true; playNext(); } }
        a.onended = advance;
        a.onerror = advance; // a failed sentence is skipped, never the robot voice
        a.src = src;
        var pr = a.play();
        if (pr && pr.catch) pr.catch(advance);
      }, function () { playNext(); });
    }
    function enqueue(chunk) {
      var t = spoken(chunk);
      if (!t) return;
      queue.push(fetchSpeech(t));
      if (!playing) playNext();
    }
    return {
      feed: function (visible, final) {
        if (seq !== playSeq || !voiceOn || panel.hidden) return;
        var rest = visible.slice(taken);
        if (!rest.trim()) {
          // Everything was already spoken (the reply ended on a full stop): still mark it
          // finished, or hands-free mode never re-opens the mic.
          if (final) { finalFed = true; if (!playing && !queue.length) spokenReplyDone(); }
          return;
        }
        var cut = 0;
        if (final) cut = rest.length;
        else {
          // Sentence ends (., !, ?, : before a space) and line breaks.
          var min = taken === 0 ? 30 : 140, max = 600, re = /[.!?:](?=\s)|\n/g, m;
          while ((m = re.exec(rest))) {
            var end = m.index + 1;
            if (end > max) break;
            if (end >= min) { cut = end; if (taken === 0) break; }
          }
        }
        if (cut > 0) { enqueue(rest.slice(0, cut)); taken += cut; }
        if (final) { finalFed = true; if (!playing && !queue.length) spokenReplyDone(); }
      }
    };
  }

  // Hands-free conversation: when the customer asked by speaking in Hugo's chat, listen again
  // as soon as Hugo has finished answering out loud. Typing, muting or closing ends it.
  var voiceConvo = false;
  function spokenReplyDone(tries) {
    if (!voiceConvo || panel.hidden || rec) return;
    tries = tries || 0;
    // The on-screen text can still be finishing; wait for it (up to ~10s) before listening.
    if (busy) { if (tries < 20) setTimeout(function () { spokenReplyDone(tries + 1); }, 500); else endConvo(); return; }
    var f = document.getElementById('gfaForm');
    if (f && micSupported()) setTimeout(function () { if (voiceConvo && !panel.hidden && !rec && !busy) startMic(f); }, 250);
  }

  function speakPremium(text) {
    var seq = ++playSeq, chunks = chunkText(text, 600);
    if (!chunks.length) return;
    var a = ensureAudio(), i = 0;
    var next = fetchSpeech(chunks[0]);
    function playNext() {
      if (seq !== playSeq || i >= chunks.length) return;
      var current = next;
      i++;
      if (i < chunks.length) next = fetchSpeech(chunks[i]); // fetch ahead while this one plays
      current.then(function (src) {
        if (seq !== playSeq) return;
        a.onended = playNext;
        // Hugo's own voice unavailable (e.g. a Cloudflare limit): stay silent rather than use
        // the device's robotic voice. The next reply tries again.
        a.onerror = function () {};
        a.src = src;
        var p = a.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    playNext();
  }
  function speakDevice(text) {
    if (!voiceSupported()) return;
    var synth = window.speechSynthesis, voice = chooseVoice();
    synth.cancel();
    // Short chunks: some browsers stop long utterances after ~15 seconds.
    chunkText(text, 220).forEach(function (c) {
      var u = new SpeechSynthesisUtterance(c);
      u.lang = 'en-GB'; if (voice) u.voice = voice;
      u.rate = 1.02; u.pitch = 0.95;
      synth.speak(u);
    });
  }
  function speak(text) {
    if (!voiceOn || panel.hidden) return;
    stopVoice();
    // Only Hugo's own voice (Draco via the Worker); the device voice is used only if there's no Worker at all.
    if (ttsUrl) speakPremium(text); else speakDevice(text);
  }
  function stopVoice() {
    playSeq++;
    // Never pause the silent unlock clip: interrupting it undoes the unlock on iPhone.
    if (audioEl && String(audioEl.src).indexOf('data:') !== 0) { try { audioEl.pause(); } catch (e) {} }
    if (voiceSupported()) window.speechSynthesis.cancel();
  }
  // iPhone only lets a page play sound after a tap, and only on an element started inside
  // that tap. Call this from tap handlers (Listen button, sending a message, tapping a chip).
  var audioUnlocked = false;
  function unlockAudio() {
    if (audioUnlocked || !voiceOn || !ttsUrl) return;
    var a = ensureAudio();
    a.src = SILENT_WAV;
    var p = a.play();
    if (p && p.then) p.then(function () { audioUnlocked = true; }, function () {}); else audioUnlocked = true;
  }
  function setVoice(on, fromClick) {
    voiceOn = !!on;
    try { localStorage.setItem(VOICE_KEY, voiceOn ? '1' : '0'); } catch (e) {}
    if (voiceBtn) {
      voiceBtn.classList.toggle('is-on', voiceOn);
      voiceBtn.setAttribute('aria-pressed', voiceOn ? 'true' : 'false');
      voiceBtn.setAttribute('title', voiceOn ? 'Tap to mute Hugo' : 'Tap to hear Hugo\'s replies');
      voiceBtn.setAttribute('aria-label', voiceOn ? 'Mute Hugo' : 'Read Hugo\'s replies aloud');
      var lbl = voiceBtn.querySelector('.gfa__voice-lbl'); if (lbl) lbl.textContent = voiceOn ? 'Mute' : 'Listen';
    }
    if (!voiceOn) { stopVoice(); endConvo(); return; }
    if (fromClick) {
      // Unlock the shared <audio> element inside this tap (iPhone blocks later playback otherwise).
      audioUnlocked = false;
      unlockAudio();
      // Read the latest reply straight away.
      var bots = log.querySelectorAll('.gfa-msg--bot:not(.gfa-typing)');
      var last = bots[bots.length - 1];
      speak(last ? last.innerText : 'Hi, I\'m Hugo. Voice is on.');
      track('voice_on', 'header');
    }
  }
  function initVoice() {
    voiceBtn = document.getElementById('gfaVoice');
    ttsUrl = AI_URL ? AI_URL.replace(/\/chat\/?$/, '/tts') : '';
    if (!voiceBtn || (!voiceSupported() && !ttsUrl)) return;
    voiceBtn.hidden = false;
    if (voiceSupported()) window.speechSynthesis.onvoiceschanged = function () { pickedVoice = null; };
    var saved = null; try { saved = localStorage.getItem(VOICE_KEY); } catch (e) {}
    setVoice(saved !== '0', false); // on unless this visitor has muted Hugo before
    voiceBtn.addEventListener('click', function () { setVoice(!voiceOn, true); });
  }

  /* ---------- Mic: customers can speak instead of typing ---------- */
  // Records one spoken question, sends it to the Worker's /stt (Deepgram Nova-3, British English)
  // and submits the words as if typed. Works in any form that has a .gfa-mic button: Hugo's chat,
  // the product-page expert and the homepage/collection bands. Stops by itself after a pause.
  var sttUrl = '', rec = null;
  var MIC_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>';
  function micSupported() { return !!(sttUrl && navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder); }
  function micButton() { return micSupported() ? '<button type="button" class="gfa-mic" aria-label="Speak your question" title="Tap and speak">' + MIC_SVG + '</button>' : ''; }
  function pickMime() {
    var c = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'];
    for (var i = 0; i < c.length; i++) { if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(c[i])) return c[i]; }
    return '';
  }
  function micNote(input, msg) {
    var ph = input.getAttribute('data-ph') || input.placeholder;
    input.setAttribute('data-ph', ph);
    input.value = '';
    input.placeholder = msg;
    clearTimeout(input._phT);
    if (msg !== ph) input._phT = setTimeout(function () { input.placeholder = ph; }, 5000);
  }
  function startMic(form) {
    if (rec) { stopMic(); return; }
    stopVoice();
    unlockAudio(); // this tap also lets Hugo speak the answer on iPhone
    var input = form.querySelector('input'), btn = form.querySelector('.gfa-mic');
    if (!input.getAttribute('data-ph')) input.setAttribute('data-ph', input.placeholder);
    // In a hands-free conversation the microphone stays connected between questions, so
    // phones don't ask for permission again each turn.
    var live = keptStream && keptStream.getAudioTracks().some(function (t) { return t.readyState === 'live'; });
    (live ? Promise.resolve(keptStream) : navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } })).then(function (stream) {
      keptStream = null;
      var mime = pickMime();
      var mr = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
      rec = { mr: mr, stream: stream, chunks: [], form: form, input: input, btn: btn };
      mr.ondataavailable = function (e) { if (e.data && e.data.size) rec.chunks.push(e.data); };
      mr.onstop = finishMic;
      mr.start();
      btn.classList.add('is-rec');
      btn.setAttribute('aria-label', 'Stop listening');
      micNote(input, 'Listening… just speak, then pause');
      // Stop after ~1.5s of quiet once they've spoken, or 30s at most, or 8s if nothing is said.
      try {
        var AC = window.AudioContext || window.webkitAudioContext, ac = new AC();
        var an = ac.createAnalyser(); an.fftSize = 1024;
        ac.createMediaStreamSource(stream).connect(an);
        rec.ac = ac;
        var data = new Uint8Array(an.fftSize), heard = false, started = Date.now(), quietSince = started;
        (function loop() {
          if (!rec || rec.mr !== mr) return;
          an.getByteTimeDomainData(data);
          var sum = 0;
          for (var i = 0; i < data.length; i++) { var v = (data[i] - 128) / 128; sum += v * v; }
          var now = Date.now();
          if (Math.sqrt(sum / data.length) > 0.04) { heard = true; quietSince = now; }
          if (!heard && now - started > 10000) { rec.silent = true; stopMic(); return; }
          if ((heard && now - quietSince > 1500) || now - started > 30000) { stopMic(); return; }
          requestAnimationFrame(loop);
        })();
      } catch (e) { rec.timer = setTimeout(stopMic, 15000); }
    }).catch(function () {
      micNote(input, 'Microphone blocked. Allow it in your browser, or type your question');
    });
  }
  function stopMic() { if (rec) { try { if (rec.mr.state !== 'inactive') rec.mr.stop(); } catch (e) {} } }
  var keptStream = null;
  function dropStream() {
    if (keptStream) { keptStream.getTracks().forEach(function (t) { t.stop(); }); keptStream = null; }
  }
  function endConvo() { voiceConvo = false; dropStream(); }
  function finishMic() {
    var r = rec; rec = null;
    if (!r) return;
    if (r.form.id === 'gfaForm' && voiceOn && !r.silent && !panel.hidden) {
      keptStream = r.stream;
      // Safety net: never leave the microphone connected for long if Hugo doesn't come back to it.
      setTimeout(function () { if (keptStream === r.stream && !rec) endConvo(); }, 120000);
    } else r.stream.getTracks().forEach(function (t) { t.stop(); });
    if (r.ac) { try { r.ac.close(); } catch (e) {} }
    clearTimeout(r.timer);
    r.btn.classList.remove('is-rec');
    r.btn.setAttribute('aria-label', 'Speak your question');
    if (r.silent) {
      // Nothing was said: end quietly (this is how a hands-free conversation finishes).
      endConvo();
      clearTimeout(r.input._phT);
      r.input.placeholder = r.input.getAttribute('data-ph') || r.input.placeholder;
      return;
    }
    r.btn.classList.add('is-busy');
    micNote(r.input, 'Got it, one moment…');
    var blob = new Blob(r.chunks, { type: r.mr.mimeType || 'audio/webm' });
    function done(text) {
      r.btn.classList.remove('is-busy');
      var ph = r.input.getAttribute('data-ph');
      if (text === null) { endConvo(); micNote(r.input, 'Sorry, I couldn\'t make that out. Could you type it?'); return; }
      if (!text) { endConvo(); micNote(r.input, 'I didn\'t catch that. Tap the mic and try again'); return; }
      clearTimeout(r.input._phT);
      r.input.placeholder = ph;
      r.input.value = text;
      voiceConvo = r.form.id === 'gfaForm' && voiceOn; // keep listening after Hugo's spoken answer
      track('voice_ask', r.form.hasAttribute('data-gfp-form') ? 'pdp' : (r.form.id === 'gfaForm' ? 'hugo' : 'band'));
      if (r.form.requestSubmit) r.form.requestSubmit();
      else r.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
    if (blob.size < 1000) { done(''); return; }
    window.fetch(sttUrl, { method: 'POST', headers: { 'Content-Type': blob.type || 'audio/webm' }, body: blob })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (j) { done((j && j.text) || ''); })
      .catch(function () { done(null); });
  }
  function initMic() {
    sttUrl = AI_URL ? AI_URL.replace(/\/chat\/?$/, '/stt') : '';
    var hugoMic = document.getElementById('gfaMic');
    if (hugoMic) hugoMic.hidden = !micSupported();
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.gfa-mic');
      if (!b) return;
      e.preventDefault();
      var f = b.closest('form');
      if (f && !b.classList.contains('is-busy')) startMic(f);
    });
  }

  /* ---------- Entry points across the site (Rufus-style) ---------- */
  var SPARK = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M11 2.5l1.9 5.4 5.4 1.9-5.4 1.9L11 17.1l-1.9-5.4-5.4-1.9 5.4-1.9z"/><path d="M18.5 14l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9z"/></svg>';

  // Suggested questions per product (keys match INFO / snippets/gf-advisor.liquid).
  var PRODUCT_QS = {
    t16: ['Is 16mm thick enough for a squat rack?', 'How many tiles do I need for a 3m x 3m room?', 'Can I lay these on floorboards?', '16mm or 20mm for my home gym?'],
    t20: ['Can I drop deadlifts on these?', 'How many tiles for my garage?', '20mm or 30mm for Olympic lifting?', 'Will these cut noise for the room below?'],
    cm20: ['How are these different from the 20mm interlocking tiles?', 'Do they smell when new?', 'How many do I need for 4m x 3m?', 'Are they good under a squat rack?'],
    t30: ['Do I need 30mm or is 20mm enough?', 'How big should my lifting platform be?', 'Will these work in an upstairs room?', 'How many tiles for a 2m x 3m platform?'],
    a30: ['Will this stop noise in my flat?', 'Do I also need the acoustic underlay?', 'How many tiles for my room?', 'Can I deadlift on these upstairs?'],
    t12: ['Are these good for a studio or PT space?', 'Blue or white fleck: which hides dust best?', 'Can I lift weights on 12mm?', 'How many tiles do I need?'],
    m17: ['Mats or tiles for my home gym?', 'Can I drop dumbbells on these?', 'How many mats for a 3m x 3m room?', 'Do I need the ramp edges?'],
    eva: ['Is EVA foam OK for weights?', 'Is it good for a kids\' play area?', 'How many tiles for my room?', 'EVA or rubber for yoga?'],
    rcut: ['Which thickness for a treadmill?', 'How many metres do I need?', 'Tiles or roll for my space?', 'Do I need to glue it down?'],
    r10: ['Crumb or smooth finish?', 'How many rolls for my gym?', 'Which thickness do I need?', 'Glue it or loose lay?'],
    rsm: ['Is this good for a spin studio?', 'How many rolls do I need?', 'Which thickness under cardio machines?', 'Smooth or crumb finish?'],
    ul: ['What goes on top of the underlay?', 'Which thickness for my flat?', 'How much noise will it stop?', 'How many rolls do I need?']
  };
  var GENERAL_QS = ['Which floor suits a garage gym with a squat rack?', 'Tiles or rolls for my space?', 'What thickness do I need for dumbbells?', 'Quiet flooring for an upstairs room'];

  function askBox(opts) {
    var chipsHtml = opts.qs.map(function (q) { return '<button type="button" class="gfa-e__chip" data-gf-ask="' + esc(q) + '" data-gf-src="' + opts.src + '"' + (opts.ctx ? ' data-gf-ctx="' + esc(opts.ctx) + '"' : '') + '>' + esc(q) + '</button>'; }).join('');
    return '<div class="gfa-e__head"><span class="gfa-e__icon">' + SPARK + '</span><div><div class="gfa-e__title">' + opts.title + '</div><div class="gfa-e__sub">' + opts.sub + '</div></div></div>' +
      '<div class="gfa-e__chips">' + chipsHtml + '</div>' +
      '<form class="gfa-e__form" data-gf-ask-form data-gf-src="' + opts.src + '"' + (opts.ctx ? ' data-gf-ctx="' + esc(opts.ctx) + '"' : '') + '>' +
      '<input type="text" maxlength="1000" placeholder="' + esc(opts.placeholder) + '" aria-label="' + esc(opts.placeholder) + '">' +
      micButton() + '<button type="submit">Ask</button></form>';
  }

  /* ---------- Product-page expert: every product has its own brain ---------- */
  // Answers inline in the box under Add to Basket. The Worker adds a product-focus brief for
  // this product (payload.product), so the expert knows its full specs, variants and prices,
  // quotes this product for the customer's room, and says so if another product fits better.
  // Each product's conversation is kept for the visit (sessionStorage) and is separate from Hugo's.
  var PDP = null;
  function pdpChip(q) { return '<button type="button" class="gfa-e__chip" data-gfp-ask="' + esc(q) + '">' + esc(q) + '</button>'; }
  function pdpKey() { return 'gfa_pdp_v1_' + PDP.handle; }
  function pdpSave() {
    try { sessionStorage.setItem(pdpKey(), JSON.stringify({ c: PDP.convo.slice(-30), h: PDP.thread.innerHTML, ch: PDP.chips.innerHTML })); } catch (e) {}
  }
  function pdpRestore() {
    try {
      var d = JSON.parse(sessionStorage.getItem(pdpKey()) || 'null');
      if (d && d.c && d.c.length) { PDP.convo = d.c; PDP.thread.innerHTML = d.h || ''; if (d.ch) PDP.chips.innerHTML = d.ch; }
    } catch (e) {}
  }
  function pdpMsg(who, html) {
    var el = document.createElement('div');
    el.className = 'gfa-e__msg gfa-e__msg--' + who;
    el.innerHTML = html;
    PDP.thread.appendChild(el);
    return el;
  }
  function pdpAsk(q) {
    if (!PDP || PDP.busy || !q) return;
    var ctx = '[About the ' + PDP.name + ' on this page] ';
    if (!aiOn()) { open(q, 'pdp', ctx); return; }
    if (PDP.convo.length >= 38) { PDP.convo = []; PDP.thread.innerHTML = ''; }
    PDP.busy = true;
    track('ask', 'pdp-expert');
    var userEl = pdpMsg('user', esc(q));
    var el = pdpMsg('bot', '<span class="gfa-e__dots"><i></i><i></i><i></i></span>');
    el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    var msgs = PDP.convo.concat([{ role: 'user', content: q }]);
    var full = '';
    window.fetch(AI_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: msgs, product: PDP.handle }) })
      .then(function (r) {
        if (!r.ok || !r.body) throw new Error('status ' + r.status);
        var reader = r.body.getReader(), dec = new TextDecoder();
        function pump() {
          return reader.read().then(function (res) {
            if (res.done) return;
            full += dec.decode(res.value, { stream: true });
            var visible = full.replace(/\[\[[^\]]*\]\]/g, '').replace(/\[\[[^\]]*$/, '').trim();
            if (visible) el.innerHTML = renderMd(visible);
            return pump();
          });
        }
        return pump();
      })
      .then(function () {
        if (!full.trim()) throw new Error('empty');
        var out = renderReply(full);
        el.innerHTML = out.html;
        PDP.convo = msgs.concat([{ role: 'assistant', content: full.trim() }]);
        if (out.chips && out.chips.length) PDP.chips.innerHTML = out.chips.map(pdpChip).join('');
        pdpSave();
      })
      .catch(function () {
        // Worker unavailable: hand the question to Hugo's panel (which falls back to the built-in advisor).
        el.remove(); userEl.remove();
        open(q, 'pdp', ctx);
      })
      .then(function () { PDP.busy = false; });
  }

  function productKeyForPage() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? keyForHandle(decodeURIComponent(m[1])) : null;
  }

  function mountEntryPoints() {
    // Product page: under the buy buttons, like "Looking for specific info?" on Amazon.
    var k = productKeyForPage();
    var buy = document.querySelector('.gp-buy__inner .gp-form-wrap') || document.querySelector('main form[action*="/cart/add"]');
    if (k && buy && !document.querySelector('.gfa-e--pdp')) {
      var name = INFO[k].name;
      var box = document.createElement('section');
      box.className = 'gfa-e gfa-e--pdp';
      if (aiOn()) {
        // Each product's own expert, answering inline on its page (see pdpAsk).
        box.innerHTML = '<div class="gfa-e__head"><span class="gfa-e__icon">' + SPARK + '</span><div>' +
          '<div class="gfa-e__title">Questions about this product?</div>' +
          '<div class="gfa-e__sub">Ask our AI product expert for the ' + esc(name) + '. Answers in seconds, with quantities and prices for your room.</div></div></div>' +
          '<div class="gfa-e__thread" aria-live="polite"></div>' +
          '<div class="gfa-e__chips">' + (PRODUCT_QS[k] || GENERAL_QS).map(pdpChip).join('') + '</div>' +
          '<form class="gfa-e__form" data-gfp-form>' +
          '<input type="text" maxlength="1000" placeholder="Ask anything about the ' + esc(name.replace(/ Rubber| Interlocking/g, '')) + '…" aria-label="Ask a question about this product">' +
          micButton() + '<button type="submit">Ask</button></form>';
        buy.parentNode.insertBefore(box, buy.nextSibling);
        PDP = { box: box, key: k, name: name, handle: LIVE[k].url.replace(/^.*\/products\//, ''), convo: [], busy: false,
          thread: box.querySelector('.gfa-e__thread'), chips: box.querySelector('.gfa-e__chips') };
        pdpRestore();
      } else {
        box.innerHTML = askBox({ qs: PRODUCT_QS[k] || GENERAL_QS, src: 'pdp', ctx: '[About the ' + name + ' on this page] ',
          title: 'Questions about this product?', sub: 'Ask Hugo, our flooring adviser. He\'ll answer in seconds, with quantities and prices for your room',
          placeholder: 'Ask about the ' + name.replace(/ Rubber| Interlocking/g, '') + '…' });
        buy.parentNode.insertBefore(box, buy.nextSibling);
      }
    }
    // Collection pages and the homepage: a "help me choose" band under the first section.
    var isCollection = /\/collections\/[^/]+\/?$/.test(location.pathname);
    var isHome = location.pathname === '/' || location.pathname === '';
    if ((isCollection || isHome) && !document.querySelector('.gfa-e--band')) {
      var anchor = document.querySelector('main [id$="__collection-header"]') || document.querySelector('main .shopify-section, main [id^="shopify-section"]');
      if (anchor) {
        var band = document.createElement('section');
        band.className = 'gfa-e gfa-e--band';
        band.innerHTML = '<div class="gfa-e__inner">' + askBox({ qs: GENERAL_QS, src: isHome ? 'home' : 'collection',
          title: isHome ? 'Describe your gym. Get the exact floor, quantity and price.' : 'Not sure which one to choose?',
          sub: 'Tell Hugo, our flooring adviser, about your room and training and he\'ll recommend the right floor in seconds',
          placeholder: 'e.g. 4m x 3m garage, squat rack, concrete floor' }) + '</div>';
        anchor.parentNode.insertBefore(band, anchor.nextSibling);
      }
    }
  }

  // Any [data-gf-ask] on the page opens the chat (with its question, if it has one).
  function bindEntryPoints() {
    // Product-page expert: chips, the question box and Add to Basket buttons in its answers.
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-gfp-ask]');
      if (c) { e.preventDefault(); pdpAsk(c.getAttribute('data-gfp-ask')); return; }
      var add = e.target.closest('.gfa-e--pdp .gfa-add');
      if (add) { e.preventDefault(); addToCart(add); }
    });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-gfp-form]');
      if (!f) return;
      e.preventDefault();
      var inp = f.querySelector('input'), q = inp && inp.value.trim();
      if (!q) { inp && inp.focus(); return; }
      inp.value = '';
      pdpAsk(q);
    });
    // Mobile bottom sheet: tapping the dimmed page (body::after backdrop) closes it.
    document.addEventListener('click', function (e) {
      if (e.target === document.body && document.documentElement.classList.contains('gfa-is-open')) close();
    });
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-gf-ask]');
      if (!el) return;
      e.preventDefault();
      closeMobileDrawer();
      var q = el.getAttribute('data-gf-ask');
      open(q || null, el.getAttribute('data-gf-src') || 'button', el.getAttribute('data-gf-ctx') || '');
    });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-gf-ask-form]');
      if (!f) return;
      e.preventDefault();
      var inp = f.querySelector('input');
      var q = inp && inp.value.trim();
      if (!q) { inp && inp.focus(); return; }
      inp.value = '';
      open(q, f.getAttribute('data-gf-src') || 'form', f.getAttribute('data-gf-ctx') || '');
    });
  }
  function closeMobileDrawer() {
    var drawer = document.getElementById('gymMobileDrawer');
    if (drawer && drawer.classList.contains('active')) {
      var c = document.getElementById('gymMobileClose');
      if (c) c.click();
    }
  }

  function init() {
    panel = document.getElementById('gfaPanel'); launch = document.getElementById('gfaLaunch');
    if (!panel || !launch) return;
    log = document.getElementById('gfaLog'); chips = document.getElementById('gfaChips'); input = document.getElementById('gfaInput');
    input.addEventListener('input', function () { endConvo(); }); // typing ends hands-free mode
    AI_URL = panel.getAttribute('data-ai') || '';
    launch.hidden = false;
    launch.addEventListener('click', toggle);
    document.getElementById('gfaClose').addEventListener('click', close);
    document.getElementById('gfaRestart').addEventListener('click', reset);
    initVoice();
    initMic(); // before mountEntryPoints, which adds mic buttons to the page boxes
    document.getElementById('gfaForm').addEventListener('submit', function (e) {
      e.preventDefault(); var v = input.value.trim(); if (!v) return; input.value = ''; handle(v);
    });
    log.addEventListener('click', function (e) { var b = e.target.closest('.gfa-add'); if (b) addToCart(b); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
    bindEntryPoints();
    try { mountEntryPoints(); } catch (e) {}
    var wasOpen = restore();
    if (history.length) setChips([['Help me choose flooring', 'recommend'], ['Talk to the team', 'human'], ['Start again', 'restart']]);
    // Reopen after navigation only on desktop; on phones the sheet would cover the new page.
    if (wasOpen && !/\/cart/.test(location.pathname) && window.matchMedia('(min-width: 750px)').matches) open(null, 'restore');
  }

  window.GFChat = { open: open, close: close, toggle: toggle, ask: function (q, source, context) { open(q, source || 'api', context); } };
  window.gfukToggleChat = toggle; // old name, kept for any leftover links

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
